// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input__control .theme--dark.v-label{font-size:14px;font-weight:300;color:#fff}", ""]);
// Exports
module.exports = exports;
